import { NAME as APP_NAME, ROUTES as APP_ROUTES } from '../constants';

export const NAME = `${APP_NAME}/ITINERARY_STATUS`;

export const REDUCER_NAME = 'itineraryStatus';

export const ROUTES = {
  ROOT: `${APP_ROUTES.ROOT}/:driverId/itinerary-status`,
};

export const LISTING_ENDPOINT = `${OPERATIONS_EDGE}/api/fleetowner/itineraries`;
